// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__210qF","consentsList":"PatientConsents_consentsList__1WJyd","consentsListEmpty":"PatientConsents_consentsListEmpty__Q3SGC"};